import { useMemo } from "react";
import { formatarData, pegarHorario } from "../utils/functions";
import SimpleTable from "../table/SimpleTable";

const TARGET_NAMES = { user: "Usuário", product: "Produto", store: "Loja", gradablemodel: "Modelo", serial: "Serial", coupon: "Cupom" };

const LogsList = ({ logs, setEdit, setEditableLog }) => {
    const columns = useMemo(() => [
        { key: "target", header: "Alvo", width: 110, labels: TARGET_NAMES },
        { key: "targetId", header: "ID alvo", width: 220 },
        { key: "user.email", header: "Usuário", width: 220 },
        { key: "createdAt", header: "Data", width: 110, format: (value) => formatarData(value) },
        { key: "createdAtTime", header: "Horário", width: 100, accessor: (row) => row.createdAt, format: (value) => pegarHorario(value) },
        {
            key: "ver", header: "", width: 70, sortable: false, hideable: false, exportable: false,
            cell: ({ row }) => <button type="button" onClick={() => { setEdit(true); setEditableLog(row); }} className="bg-blue-500 px-2 text-black hover:bg-blue-800">Ver</button>,
        },
    ], [setEdit, setEditableLog]);
    return <SimpleTable tableKey="admin-logs" columns={columns} data={logs} />;
};

export default LogsList;
